import { format } from 'date-fns';

const DAY_MS = 24 * 60 * 60 * 1000;

const getLocalCalendarDayNumber = (date) => (
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / DAY_MS
);

const withCount = (label, count) => (
    String(label).replace(/\{\{\s*count\s*\}\}/g, String(count))
);

const translateTimeLabel = (t, key, defaultValue, count) => {
    const options = count === undefined
        ? { defaultValue }
        : { count, defaultValue };
    const label = typeof t === 'function' ? t(key, options) : defaultValue;

    return count === undefined ? label : withCount(label, count);
};

const getRelativeTimeLabel = (daysAgo, t) => {
    if (daysAgo === 1) {
        return translateTimeLabel(t, 'conversation_time_yesterday', 'Yesterday');
    }

    if (daysAgo < 7) {
        return translateTimeLabel(t, 'conversation_time_days_ago', '{{count}}d ago', daysAgo);
    }

    if (daysAgo < 30) {
        const weeks = Math.floor(daysAgo / 7);
        const key = weeks === 1 ? 'conversation_time_week_one' : 'conversation_time_week_other';
        const defaultValue = weeks === 1 ? '1 week' : '{{count}} weeks';

        return translateTimeLabel(t, key, defaultValue, weeks);
    }

    if (daysAgo < 365) {
        const months = Math.floor(daysAgo / 30);
        const key = months === 1 ? 'conversation_time_month_one' : 'conversation_time_month_other';
        const defaultValue = months === 1 ? '1 month' : '{{count}} months';

        return translateTimeLabel(t, key, defaultValue, months);
    }

    const years = Math.max(1, Math.floor(daysAgo / 365));
    const key = years === 1 ? 'conversation_time_year_one' : 'conversation_time_year_other';
    const defaultValue = years === 1 ? '1 year' : '{{count}} years';

    return translateTimeLabel(t, key, defaultValue, years);
};

export const formatTime = (timestamp, t, now = new Date()) => {
    const date = new Date(timestamp);

    if (Number.isNaN(date.getTime())) {
        return '';
    }

    const daysAgo = getLocalCalendarDayNumber(now) - getLocalCalendarDayNumber(date);

    if (daysAgo > 0) {
        return getRelativeTimeLabel(daysAgo, t);
    }

    return format(date, 'h:mm a');
};

export const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
        case 'active':
            return 'green';
        case 'pending':
            return 'yellow';
        case 'closed':
            return 'red';
        default:
            return 'default';
    }
};
